import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import React, { useState, useEffect, useReducer } from "react";
import dayjs from "dayjs";
import { post } from "aws-amplify/api";
import currentUserToken from "CurrentUserToken";
import { APIStatusDialog } from "components/APIStatusDialog";
import { I18n } from "aws-amplify/utils";
import FormControl from "@mui/material/FormControl";
import FormHelperText from "@mui/material/FormHelperText";

const NewAccountAssignationDialog = ({ open, onClose, onSave }) => {
  const [account, setAccount] = useState("");
  const [patternNumber, setPatternNumber] = useState("");
  const [searchPattern1, setSearchPattern1] = useState("");
  const [searchPattern2, setSearchPattern2] = useState("");
  const [searchPattern3, setSearchPattern3] = useState("");

  const [apiStatus, setApiStatus] = useState({
    open: false,
    status: "",
    message: "",
  });

  const accountError = account === "";
  const patternNumberError = patternNumber === "";
  const searchPattern1Error = searchPattern1 === "";
  const searchPattern2Error = searchPattern2 === "";
  const isSaveDisabled =
    accountError ||
    patternNumberError ||
    searchPattern1Error ||
    searchPattern2Error;

  useEffect(() => {
    // Reset values when the dialog is opened
    if (open) {
      setAccount("");
      setPatternNumber("");
      setSearchPattern1("");
      setSearchPattern2("");
      setSearchPattern3("");
      setApiStatus({ open: false, status: "", message: "" }); // Reset API status too
    }
  }, [open]);

  const tlmModifyDescription = async (descriptions) => {
    try {
      const restOperation = post({
        apiName: "TelemonitoringAPI",
        path: "/alarm/account/map/new",
        options: {
          headers: {
            "Content-Type": "application/json",
            Authorization: `${await currentUserToken()}`,
          },
          body: descriptions,
        },
      });
      return restOperation;
    } catch (error) {}
  };

  const handleSave = async () => {
    const newAccountAssignation = {
      account,
      pattern_number: patternNumber,
      search_pattern_1: searchPattern1,
      search_pattern_2: searchPattern2,
      search_pattern_3: searchPattern3,
    };

    try {
      setApiStatus({
        open: true,
        status: "pending",
        message: I18n.get("Creating account assignment"),
      });
      const restOperation = await tlmModifyDescription(newAccountAssignation);
      const response = await restOperation.response;
      if (response.statusCode === 200) {
        setApiStatus({
          open: true,
          status: "success",
          message: I18n.get("Account assignment successfully created"), // Update the message to reflect the action
        });
      } else {
        setApiStatus({
          open: true,
          status: "error",
          message: I18n.get("Failed to create account assignation"), // Update the message for clarity
        });
      }
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        onClose();
      }, 2000);
    } catch (error) {
      setApiStatus({
        open: true,
        status: "error",
        message: I18n.get("Failed to create account assignation"), // Update the message for clarity
      });
      setTimeout(() => {
        setApiStatus((prevState) => ({ ...prevState, open: false }));
        onClose(); // Close the dialog after showing error message
      }, 2000);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{I18n.get("New Account Assignment")}</DialogTitle>
      <DialogContent>
        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Account")}
            value={account}
            onChange={(e) => setAccount(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <FormHelperText error={accountError}>
            {accountError ? "Mandatory field" : " "}
          </FormHelperText>
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
  <TextField
    label={I18n.get("Pattern Number")}
    value={patternNumber}
    onChange={(e) => {
      const input = e.target.value.replace(/\D/g, ""); // Rimuovi caratteri non numerici
      if (input !== "0") {
        setPatternNumber(input); // Permetti solo numeri diversi da 0
      }
    }}
    fullWidth
    margin="normal"
    required
  />
  <FormHelperText error={patternNumberError}>
    {patternNumberError ? "Mandatory field" : " "}
  </FormHelperText>
</FormControl>


        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Search Pattern 1")}
            value={searchPattern1}
            onChange={(e) => setSearchPattern1(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <FormHelperText error={searchPattern1Error}>
            {searchPattern1Error ? "Mandatory field" : " "}
          </FormHelperText>
        </FormControl>

        <FormControl fullWidth margin="normal" className="custom-form-control">
          <TextField
            label={I18n.get("Search Pattern 2")}
            value={searchPattern2}
            onChange={(e) => setSearchPattern2(e.target.value)}
            fullWidth
            margin="normal"
            required
          />
          <FormHelperText error={searchPattern2Error}>
            {searchPattern2Error ? "Mandatory field" : " "}
          </FormHelperText>
        </FormControl>

        <TextField
          label={I18n.get("Search Pattern 3")}
          value={searchPattern3}
          onChange={(e) => setSearchPattern3(e.target.value)}
          fullWidth
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary">
          {I18n.get("Cancel")}
        </Button>
        <Button onClick={handleSave} color="primary" disabled={isSaveDisabled}>
          {I18n.get("Save")}
        </Button>
      </DialogActions>
      <APIStatusDialog
        open={apiStatus.open}
        status={apiStatus.status}
        message={apiStatus.message}
      />
    </Dialog>
  );
};

export default NewAccountAssignationDialog;
